import axios from 'axios'

// eslint-disable-next-line import/prefer-default-export
export class PastaService {
    static serverURL = `${process.env.VUE_APP_HOST_API_BACKEND}`;

    static getALLPastas() {
      const dataURL = `${this.serverURL}/folders`
      // console.log('dataURL.pasta');
      //  console.log(dataURL);
      return axios.get(dataURL)
    }

    static getPasta(folderId) {
      const dataURL = `${this.serverURL}/folder/${folderId}`
      // console.log('dataURL');
      // console.log(dataURL);
      return axios.get(dataURL)
    }

    static getPastaUserId(pastaId) {
      const dataURL = `${this.serverURL}/pastaUser/${pastaId}`
      // console.log('dataURL');
      // console.log(dataURL);
      return axios.get(dataURL)
    }

    static createPasta(folder) {
      const dataURL = `${this.serverURL}/folder/`
      // console.log('dataURL.folder');
      // console.log(dataURL,folder);
      return axios.post(dataURL, folder)
    }

    static updatePasta(folder, folderId) {
      const dataURL = `${this.serverURL}/folder/${folderId}`
      return axios.put(dataURL, folder)
    }

    static deletePasta(folderId) {
      const dataURL = `${this.serverURL}/folder/${folderId}`
      console.log(dataURL)
      return axios.delete(dataURL)
    }
}
